export const footerLinksForRepLayout = [
  {
    title: 'Terms & Conditions',
    href: '/team/content-pages/terms-conditions',
    target: '_blank'
  },
  {
    title: 'Privacy Policy',
    href: '/team/content-pages/privacy-policy',
    target: '_blank'
  },
  {
    title: "FAQ's",
    href: '/team/about-ignite',
    target: '_self'
  },
  {
    title: 'Logout',
    href: '/team/logout',
    target: '_self'
  }
];

export const footerLinksForUserLayout = [
  {
    title: 'Home',
    href: '/',
    target: ''
  },
  {
    title: 'Contact us',
    href: '/contact-us',
    target: ''
  },
  {
    title: 'Terms and conditions',
    href: '/content-pages/terms-conditions',
    target: '_blank'
  },
  {
    title: 'Privacy policy',
    href: '/content-pages/privacy-policy',
    target: '_blank'
  },
  {
    title: 'Ignite Mastercard Management',
    href: 'https://www.imperial-ignite-mastercard.co.uk',
    target: '_blank'
  },
  {
    title: 'Log out',
    href: '/logout',
    target: ''
  }
];

export const footerLinksForPreloginUserLayout = [
  {
    title: 'Home',
    href: '/',
    target: ''
  },
  {
    title: 'Contact us',
    href: '/contact',
    target: ''
  },
  {
    title: 'Terms and conditions',
    href: '/content-pages/terms-conditions',
    target: '_blank'
  },
  {
    title: 'Privacy policy',
    href: '/content-pages/privacy-policy',
    target: '_blank'
  }
];
